// components/FloatingBackground.jsx
const FloatingBackground = () => {
  const symbols = [
    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },
    { char: "Ξ", color: "#627eea", delay: 1 },
    { char: "₮", color: "#26a17b", delay: 1.5 },
    { char: "Ł", color: "#bfbbbb", delay: 2 },
    { char: "◊", color: "#8c4af0", delay: 2.5 },
    { char: "Ⓧ", color: "#344675", delay: 3 },
    { char: "Ⓜ", color: "#ff6600", delay: 3.5 },
    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },

    { char: "A", color: "#ff6600", delay: 3.5 },
    { char: "B", color: "#f7931a", delay: 0 },
    { char: "C", color: "#c2a633", delay: 0.9 },
    { char: "D", color: "#ff6600", delay: 3.5 },
    { char: "E", color: "#f7931a", delay: 0 },
    { char: "F", color: "#c2a633", delay: 0.2 },
    { char: "G", color: "#ff6600", delay: 3.2 },
    { char: "H", color: "#f7931a", delay: 0 },
    { char: "I", color: "#c2a633", delay: 0.1 },
    { char: "J", color: "#ff6600", delay: 3.1 },
    { char: "K", color: "#f7931a", delay: 0 },
    { char: "L", color: "#c2a633", delay: 0.2 },

    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },
    { char: "Ξ", color: "#627eea", delay: 1 },
    { char: "₮", color: "#26a17b", delay: 1.5 },
    { char: "Ł", color: "#bfbbbb", delay: 2 },
    { char: "◊", color: "#8c4af0", delay: 2.5 },
    { char: "Ⓧ", color: "#344675", delay: 3 },
    { char: "Ⓜ", color: "#ff6600", delay: 3.5 },
    { char: "₿", color: "#f7931a", delay: 0 },
    { char: "Ð", color: "#c2a633", delay: 0.5 },

    { char: "A", color: "#ff6600", delay: 3.5 },
    { char: "B", color: "#f7931a", delay: 0 },
    { char: "C", color: "#c2a633", delay: 0.9 },
    { char: "D", color: "#ff6600", delay: 3.5 },
    { char: "E", color: "#f7931a", delay: 0 },
    { char: "F", color: "#c2a633", delay: 0.2 },
    { char: "G", color: "#ff6600", delay: 3.2 },
    { char: "H", color: "#f7931a", delay: 0 },
    { char: "I", color: "#c2a633", delay: 0.1 },
    { char: "J", color: "#ff6600", delay: 3.1 },
    { char: "K", color: "#f7931a", delay: 0 },
    { char: "L", color: "#c2a633", delay: 0.2 },
  ];

  const repeatedSymbols = Array.from(
    { length: 20 },
    () => symbols[Math.floor(Math.random() * symbols.length)]
  );

  return (
    <div className="floating-background">
      <div className="floating-symbols">
        {repeatedSymbols.map((symbol, index) => {
          const isReverse = Math.random() > 0.5;
          const duration = Math.random() * 10 + 5;
          const delay = Math.random() * 5;
          const left = `${Math.random() * 100}%`;
          const top = `${Math.random() * 100}%`;

          return (
            <div
              key={index}
              className={`floating-symbol ${isReverse ? "reverse-float" : ""}`}
              style={{
                color: symbol.color,
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
                left,
                top,
              }}
            >
              {symbol.char}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FloatingBackground;
